import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export default function SortableTeamNumHeader({
	label,
	labelContent,
	sortKey,
	activeSort,
	onSort,
	className = '',
}) {
	const isActive = activeSort === sortKey;
	return (
		<th
			className={`new-results-num new-results-th-sortable ${className} ${isActive ? 'new-results-th-sortable--active' : ''}`.trim()}
			aria-sort={isActive ? 'descending' : 'none'}
		>
			<button
				type="button"
				className="new-results-th-sort-btn"
				onClick={() => onSort(sortKey)}
			>
				<span className="new-results-th-sort-label">{labelContent ?? label}</span>
				{isActive && (
					<ArrowDownwardIcon className="new-results-th-sort-arrow" aria-hidden />
				)}
			</button>
		</th>
	);
}
